export default Object.freeze({
  MOBILE_SCREEN_TILL: {
    breakPoint: "sm",
    width: 959, //960
  },
});
